import React from 'react'
import './index.less'
export default class Footer extends React.Component {
    render() {
        return (
            <div className="footer">
              {/* 版权所有：商家管理系统（推荐使用谷歌浏览器，可以获得更佳操作页面体验） 技术支持：寻梦科技*/}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Footer/index.js